// extracted by mini-css-extract-plugin
export default {"dialog":"WelcomeDialog_dialog__xSFvP","formButton":"WelcomeDialog_formButton__Dtto0"};